import { Chip, Divider, Rating, Stack, Typography } from "@mui/material";
import React, { useRef } from "react";
import GlobalButton from "../../components/button";
import { useSelector } from "react-redux";
import LoginDialog from "../../components/loginDialog";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { t } from "i18next";

const PackageInfo = ({ packageDetail }) => {
  const navigate = useNavigate();
  const { url } = useParams();
  const [searchParams] = useSearchParams();
  const openLoginDialog = useRef(null);
  const userData = useSelector((state) => state.userReducer.user);
  const refferedBy = searchParams.get("via");
  const { currentLanguage } = useSelector((state) => state.translationReducer);

  const renderStockChip = () => {
    return (
      <Chip
        label={t("inStock")}
        sx={{
          background: "linear-gradient(45deg, #00C853, #69F0AE)",
          color: "#ffffff",
          fontWeight: "bold",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          borderRadius: "4px",
          padding: "0 8px",
          overflow: "hidden",
        }}
      />
    );
  };
  return (
    <Stack gap={1}>
      <Typography variant="body1" fontWeight={500} textTransform={"capitalize"}>
        {t("createdBy")} :{" "}
        {`${packageDetail?.createdBy?.firstname} ${packageDetail?.createdBy?.lastname}`}
      </Typography>
      <Stack gap={2} direction={"row"} alignItems={"center"}>
        <Typography
          variant="body1"
          fontWeight={500}
          textTransform={"capitalize"}
        >
          {t("availability")} :
        </Typography>
        {renderStockChip()}
      </Stack>
      <Typography variant="h6" fontWeight={500}>
        {packageDetail?.name[currentLanguage]}
      </Typography>
      <Rating
        // defaultValue={5}
        readOnly
        value={packageDetail?.rating}
        sx={{
          "&.MuiRating-root": {
            color: "text.orangeRed",
          },
        }}
      />
      {packageDetail?.description[currentLanguage] && (
        <Typography>{packageDetail?.description[currentLanguage]}</Typography>
      )}
      <Divider sx={{ my: "1.5rem" }} />
      <GlobalButton
        className="button-shake-animation"
        btnText={"orderNow"}
        handleClickBtn={() => {
          if (!userData) {
            openLoginDialog.current.openDialog();
          } else {
            navigate(
              `/check-out?package=${url}${
                refferedBy ? `&via=${refferedBy}` : ""
              }`
            );
          }
        }}
        styleProps={{
          backgroundColor: "text.orangeRed",
          width: "100%",
          height: 50,
          borderRadius: 0,
          fontSize: "1rem",
        }}
      />
      <LoginDialog ref={openLoginDialog} />
    </Stack>
  );
};

export default PackageInfo;
